import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const MAIN_TEMPLATES_LIST = "mailTemplates";
// QSIGN fetch šablony
export function fetchfindMailTemplatesIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
        MAIN_TEMPLATES_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findMailTemplates();
        },
        force
      )
    );
  };
}
